import qknColors from './qknColors';

export const bizPaletteLight = Object.freeze({
  bizColor0: {
    light: qknColors.grey[100],
    main: qknColors.grey[600],
    dark: qknColors.grey[700],
  },
  bizColor1: {
    light: qknColors.sky[50],
    main: qknColors.sky[600],
    dark: qknColors.sky[800],
  },
  bizColor2: {
    light: qknColors.green[50],
    main: qknColors.green[700],
    dark: qknColors.green[800],
  },
  bizColor3: {
    light: qknColors.lime[100],
    main: qknColors.lime[700],
    dark: qknColors.lime[900],
  },
  bizColor4: {
    light: qknColors.yellow[50],
    main: qknColors.yellow[600],
    dark: qknColors.yellow[800],
  },
  bizColor5: {
    light: qknColors.cream[50],
    main: qknColors.cream[600],
    dark: qknColors.cream[700],
  },
  bizColor6: {
    light: qknColors.deepOrange[50],
    main: qknColors.deepOrange[700],
    dark: qknColors.deepOrange[800],
  },
  bizColor7: {
    light: qknColors.red[50],
    main: qknColors.red[600],
    dark: qknColors.red[700],
  },
  bizColor8: {
    light: qknColors.magenta[50],
    main: qknColors.magenta[600],
    dark: qknColors.magenta[700],
  },
  bizColor9: {
    light: qknColors.purple[100],
    main: qknColors.purple[600],
    dark: qknColors.purple[700],
  },
  bizColor10: {
    light: qknColors.blue[100],
    main: qknColors.blue[700],
    dark: qknColors.blue[800],
  },
} as const);

export const bizPaletteDark = Object.freeze({
  bizColor0: {
    light: qknColors.grey[700],
    main: qknColors.grey[400],
    dark: qknColors.grey[100],
  },
  bizColor1: {
    light: qknColors.sky[800],
    main: qknColors.sky[600],
    dark: qknColors.sky[100],
  },
  bizColor2: {
    light: qknColors.green[900],
    main: qknColors.green[500],
    dark: qknColors.green[100],
  },
  bizColor3: {
    light: qknColors.lime[900],
    main: qknColors.lime[800],
    dark: qknColors.lime[200],
  },
  bizColor4: {
    light: qknColors.yellow[800],
    main: qknColors.yellow[600],
    dark: qknColors.yellow[50],
  },
  bizColor5: {
    light: qknColors.cream[900],
    main: qknColors.cream[700],
    dark: qknColors.cream[100],
  },
  bizColor6: {
    light: qknColors.deepOrange[900],
    main: qknColors.deepOrange[800],
    dark: qknColors.deepOrange[100],
  },
  bizColor7: {
    light: qknColors.red[900],
    main: qknColors.red[700],
    dark: qknColors.red[100],
  },
  bizColor8: {
    light: qknColors.magenta[900],
    main: qknColors.magenta[600],
    dark: qknColors.magenta[100],
  },
  bizColor9: {
    light: qknColors.purple[800],
    main: qknColors.purple[500],
    dark: qknColors.purple[100],
  },
  bizColor10: {
    light: qknColors.blue[800],
    main: qknColors.blue[500],
    dark: qknColors.blue[100],
  },
} as const);
